import React from 'react'
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom'

export const withRouter = (WrappedComponent) => (props) => {
  const [searchParams] = useSearchParams()
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  return <WrappedComponent {...props} navigate={navigate} params={params} searchParams={searchParams} location={location} />
}
